import { Input, Button } from '../shared/components/ui'

export function ContactPage() {
  return (
    <div>
      <section className="relative text-gray-700 body-font">
        <div className="container px-5 py-24 mx-auto">
          <div className="flex flex-col w-full mb-12 text-center">
            <h1 className="mb-4 text-2xl font-medium text-gray-900 sm:text-3xl title-font">Contact Us</h1>
            <p className="mx-auto text-base leading-relaxed lg:w-2/3">
              Please fill out the form below and we will get back to you as soon as possible.
            </p>
          </div>
          <div className="mx-auto lg:w-1/2 md:w-2/3">
            <div className="flex flex-wrap -m-2">
              <div className="w-1/2 p-2">
                <div className="relative">
                  <label className="text-sm leading-7 text-gray-600">Name</label>
                  <Input
                    type="text"
                    id="name"
                    name="name"
                    className="w-full"
                  />
                </div>
              </div>
              <div className="w-1/2 p-2">
                <div className="relative">
                  <label className="text-sm leading-7 text-gray-600">Email</label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full"
                  />
                </div>
              </div>
              <div className="w-full p-2">
                <div className="relative">
                  <label className="text-sm leading-7 text-gray-600">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    className="w-full h-32 px-3 py-2 text-base leading-6 text-gray-700 transition-colors border border-gray-300 rounded-md outline-none resize-none focus:border-blue-600 focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 bg-white"
                  ></textarea>
                </div>
              </div>
              <div className="w-full p-2">
                <Button
                  variant="primary"
                  size="lg"
                  className="mx-auto"
                  // onClick={() => {
                  //   window.open(`mailto:support@atcreate.ca?subject=AtCreate Support&body=${body}`)
                  // }}
                >
                  SUBMIT
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
